<template>
  <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="11" cy="11" r="10.3" stroke="currentColor" stroke-width="1.4" />
    <path d="M11.3438 6.73438V15.5303" stroke="currentColor" stroke-width="1.4" />
    <path d="M6.1875 11.2832L11.3437 6.12695L16.5 11.2832" stroke="currentColor" stroke-width="1.4" />
  </svg>
</template>
